import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux'
import { componentPhaseSelectorChange } from 'state-management/actions'
import { getGlobalProps } from 'state-management/selectors'
import { getPhaseRSC, getLongEventRSC, getLongPhaseRSC } from 'helpers/rsc'
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import { Link } from 'react-router-dom';
import NotAvailable from '../../NotAvailable';



const sortDataByFieldDesc = (array, field) => {
    return array.sort((a, b) => b[field] - a[field])
};

export default function PhaseList({ items, extraData }) {
    let result = [];
    // result = items?.event?.phases ? items.event.phases.filter(row => (row.type === '3')) : []
    result = sortDataByFieldDesc(items, "order");
    const postList = result ? (
        <div className='container-phase'>
            <ul className={`container d-flex  flex-column  flex-md-row   `}>
                {result && result.map((item, index) => (
                    <PhaseItem key={index} data={item} extraData={extraData} />  // {...{ [resouceName]:item }} its the same like  person={item} 
                ))}
            </ul>
        </div>

    ) : (
        '' //<NotAvailable />
    )
    return (
        <>
            {postList}
        </>
    )
}


export function PhaseItem({ data, extraData }) {
    /*
    const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();
    const _phaseSelected = globalProps.components.phaseSelector.elementSelected
    useEffect(() => {
        dispatch(componentPhaseSelectorChange(phaseUrl))
    }, []);

    */
    const isH2H = extraData?.isH2H //data?.eventUnit?.type.startsWith("H") 
    let sw = true;
    //get url values 
    const params = useUrlFriendlyToParameters();
    //Copy object in order to change 
    let paramsURL = { ...params }
    //Pahse from URL 
    const phaseUrl = getPhaseRSC(paramsURL.mirs_rsc)
    //Change rsc from url with new value from data  
    paramsURL.mirs_rsc = data.code// getLongPhaseRSC(data.code)
    //path url by default
    let path = 'results'



    if (isH2H) {
        paramsURL.mirs_rsc = getLongEventRSC(paramsURL.mirs_rsc)
        //url pools 
        if (data.order === '8') {
            path = 'pool'
            //Remove phases pooles A,B,C... only left Pooles
            if (!data.code.endsWith("--")) { sw = false }
        } else {
            path = 'bracket'
        }
    }
    //url results
    const url = useGetURL(paramsURL, path)
    const comp =
        <li className={`phase-item    ${(phaseUrl === data.code) ? "active" : ""}`} >

            <CustomLink to={url} position={data.order} bracketCode={'FNL'}>
                <>
                    <span className="text-center phase-box">{data.shortDescription}</span>
                </>
            </CustomLink>
        </li >



    if ((data.code.indexOf('TMRY') === -1) && (sw)) {
        return (
            <>
                {comp}
            </>
        )
    } else { return null }

}


function CustomLink({ children, to, position, bracketCode }) {
    return (
        <Link to={to} state={{ bracketPosition: position, bracketCode: bracketCode }} >
            {children}
        </Link>

    );
}








